import { batch } from "@preact/signals-react"

import { authorizedData } from "./authorized"
import { marketDetailsData } from "./marketDetails"
import { marketPositionAllData } from "./marketPosition"
import { numbersData } from "./numbers"
import { topSellersAllData } from "./top_sellers"


export const resetMarketplacesGeneral = () => batch(() => {
    authorizedData.value = []
    marketDetailsData.value = []
    marketPositionAllData.value = {}
    numbersData.value = {}
    topSellersAllData.value = {}
})